<script>
  import { supabase } from '../../lib/supabase.js';
  import { showToast } from '../../lib/stores/toast.js';

  let { pageId, workspaceId, onpick, onclose } = $props();

  let buttons = $state([]);
  let highlightIdx = $state(0);
  let loaded = $state(false);

  async function load() {
    const { data } = await supabase
      .from('bb_tech_buttons')
      .select('id, name, is_hidden')
      .eq('page_id', pageId)
      .is('deleted_at', null)
      .eq('is_hidden', false)
      .order('sort_order', { ascending: true });
    buttons = data || [];
    loaded = true;
  }

  function onKey(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      highlightIdx = (highlightIdx + 1) % buttons.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      highlightIdx = highlightIdx <= 0 ? buttons.length - 1 : highlightIdx - 1;
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      pick();
    } else if (e.key === 'Escape') {
      onclose?.();
    }
  }

  function pick() {
    if (buttons.length === 0) return;
    const b = buttons[highlightIdx];
    if (!b) return;
    onpick?.(b.id);
  }

  $effect(() => { load(); });
</script>

<svelte:window on:keydown={onKey} />

<div class="pp-overlay" onclick={onclose}>
  <div class="pp-modal pp-narrow" onclick={(e) => e.stopPropagation()}>
    <header class="pp-header">
      <h4>Pick a button to follow</h4>
      <button class="pp-x" onclick={onclose} type="button">×</button>
    </header>
    <div class="pp-body">
      {#if !loaded}
        <p class="cp-muted">Loading…</p>
      {:else if buttons.length === 0}
        <p class="cp-muted">No buttons on this page yet. Add buttons first.</p>
      {:else}
        <p class="cp-hint">↑↓ navigate, Enter to pick</p>
        {#each buttons as b, idx}
          <button
            class="cp-row"
            class:active={idx === highlightIdx}
            onclick={() => { highlightIdx = idx; pick(); }}
            onmouseenter={() => highlightIdx = idx}
            type="button"
          >{b.name}</button>
        {/each}
      {/if}
    </div>
  </div>
</div>

<style>
  .pp-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 250; }
  .pp-modal { background: #0a0a0c; border: 1px solid rgba(212,175,55,0.3); border-radius: 12px; max-height: 80vh; display: flex; flex-direction: column; }
  .pp-narrow { width: 380px; max-width: 95vw; }
  .pp-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid rgba(255,255,255,0.06); }
  .pp-header h4 { margin: 0; font-family: 'DM Serif Display', serif; font-size: 15px; color: #f0efe9; }
  .pp-x { background: rgba(255,255,255,0.06); color: #b8b8bc; border: 1px solid rgba(255,255,255,0.1); width: 26px; height: 26px; border-radius: 50%; cursor: pointer; font-size: 14px; }
  .pp-body { padding: 12px 16px; overflow-y: auto; display: flex; flex-direction: column; gap: 4px; }
  .cp-muted { color: #9aa0a6; font-size: 12px; margin: 0; }
  .cp-hint { color: #6a6a6e; font-size: 10px; font-family: 'JetBrains Mono', monospace; letter-spacing: 1px; margin: 0 0 6px; }
  .cp-row { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06); color: #d8d8dc; padding: 8px 12px; border-radius: 6px; cursor: pointer; font-size: 13px; text-align: left; }
  .cp-row.active { background: rgba(212,175,55,0.15); border-color: rgba(212,175,55,0.4); color: #d4af37; }
</style>
